var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.041 13.4814H7.54102V10.9814L15.041 3.48145L17.541 5.98145L10.041 13.4814Z",
    stroke: "#CACBCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 5.35645L15.666 7.85645",
    stroke: "#CACBCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.916 10.3564V17.2314C16.916 17.3972 16.8502 17.5562 16.733 17.6734C16.6157 17.7906 16.4568 17.8564 16.291 17.8564H3.79102C3.62526 17.8564 3.46628 17.7906 3.34907 17.6734C3.23186 17.5562 3.16602 17.3972 3.16602 17.2314V4.73145C3.16602 4.56569 3.23186 4.40671 3.34907 4.2895C3.46628 4.17229 3.62526 4.10645 3.79102 4.10645H10.666",
    stroke: "#CACBCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIco);
export default __webpack_public_path__ + "static/media/edit_ico.129db3d75a9f0d2148dd9c2d71afe658.svg";
export { ForwardRef as ReactComponent };